export enum Events {
  ShareInitiated = 'Share Initiated',
  ClickPostDiscussion = 'click_post_discussion',
  ViewDiscussionMenu = 'view_discussion_menu',
  ClickMenuDiscussion = 'click_menu_discussion',
  DiscussionViewed = 'discussion_viewed',
  DiscussionSubscribed = 'discussion_subscribed',
  CommentUnique = 'comment_unique',
  ClickCommentCount = 'click_comment_count',
  ClickLikeCount = 'click_like_count',
  ClickShareCount = 'click_share_count',
  ClickEngage = 'click_engage',
}
